import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
// import { SwUpdate } from '@angular/service-worker';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));

// if ('serviceWorker' in navigator) {
//   platformBrowserDynamic().bootstrapModule(AppModule).then(moduleRef => {
//     const swUpdate = moduleRef.injector.get(SwUpdate, null);
//     if (swUpdate) {
//       swUpdate.available.subscribe(event => {
//         // Optionally skip waiting and activate update silently
//         swUpdate.activateUpdate().then(() => {
//           // You control how to notify users — or not at all
//           console.log('App updated in the background');
//         });
//       });
//     }
//   });
// }